import { render, staticRenderFns } from "./box_order.vue?vue&type=template&id=cbe3c3e0&scoped=true&"
import script from "./box_order.vue?vue&type=script&lang=js&"
export * from "./box_order.vue?vue&type=script&lang=js&"
import style0 from "./box_order.vue?vue&type=style&index=0&id=cbe3c3e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbe3c3e0",
  null
  
)

export default component.exports